import {
  GLOBAL_COMMUNITY,
  OPEN_COMMUNITY,
  PUBLIC_COMMUNITY
} from '../../../components/CommentInput/MentioningMenuUtilities';
import { ALL_COMMUNITIES_CHOICE } from '../../../utils/community/communityConstants';
import { getCurrentUserCommunities } from '../user/userSelectors';

export const getCommunityName = (state, communityId) => {
  return state.communities &&
    state.communities.communities &&
    state.communities.communities[communityId]
    ? state.communities.communities[communityId].name
    : null;
};

export const getAllCommunities = (state) => state?.communities?.communities;

export const getUserVisibleCommunities = (state) => {
  const contentCommunities = getAllCommunities(state);
  const myCommunities = getCurrentUserCommunities(state);
  const commonCommunities = {};
  if (myCommunities && contentCommunities) {
    Object.keys(contentCommunities).forEach((key) => {
      const contentCommunityType = contentCommunities[key]?.type;
      if (
        myCommunities[key] ||
        contentCommunityType === PUBLIC_COMMUNITY ||
        contentCommunityType === GLOBAL_COMMUNITY ||
        contentCommunityType === OPEN_COMMUNITY
      ) {
        commonCommunities[key] = contentCommunities[key];
      }
    });
  }
  return commonCommunities;
};

export const getCommunityFilter = (state) => state.communities.communityFilter;

export const getCommunityPostingId = (state) =>
  state.communities.communityPostId;

export const getCommunityIds = (state) => {
  const communityFilter = getCommunityFilter(state);
  if (ALL_COMMUNITIES_CHOICE === communityFilter) return [];
  return [communityFilter.id];
};

export const getCommunityType = (state, communityId) => {
  const { communities } = state;
  const communityPostingId = communities?.communityPostId;

  // If this is true it means the user has selected a specific community.
  // Use this community's type for all comments
  if (communityPostingId) {
    const userCommunities = communities?.communities;
    const selectedCommunity = userCommunities[communityPostingId];
    return selectedCommunity.type;
  }

  // If we get here it means we are view comments from multiple communities.
  // We first need to check if we have our user's community data
  // then we can get the community type for the comment.
  if (communities?.communities) {
    return communities?.communities[communityId]?.type;
  }

  return null;
};

/**
 * Get the community id if the content only has one community
 * This is used in scenarios where a community id is not provided at
 * application initialisation
 * @param {object} state
 * @returns community id when community count === 1 or null
 */
export const getSingleCommunityId = (state) => {
  const communityCount = state.content?.communities?.length;
  if (communityCount === 1) {
    return state.content.communities[0].id;
  }
  return null;
};

export default {
  getCommunityName,
  getAllCommunities,
  getCommunityFilter,
  getCommunityIds
};
